import { Button, Flex, Pagination, Select, Typography } from 'antd'
import React, { useMemo } from 'react'
import { PaginationFirstIcon, PaginationLastIcon } from 'src/assets/icons'
import { defaultPageSize, defaultPageSizeOptions, defaultPagination } from '../table.constants'
import { useTranslation } from 'react-i18next'
import { useTableContext } from './TableProvider'

const TablePagination: React.FC = () => {
  const { t } = useTranslation()
  const {
    total = 0,
    currentPage = defaultPagination,
    pageSize = defaultPageSize,
    paginationPageSizeSelector = defaultPageSizeOptions,
    displayPagination = true,
    disableTableControl = false,
    onPaginationChange,
    onJumpToFirst,
    onJumpToLast,
    onPageSizeChange,
  } = useTableContext()

  const pageSizeDropdwonOptions = useMemo(
    () =>
      (paginationPageSizeSelector as Array<number>)?.map((item) => ({
        label: item.toString(),
        value: item,
      })),
    [paginationPageSizeSelector],
  )

  const showingFrom = useMemo(
    () => (total !== 0 ? currentPage * pageSize - pageSize + defaultPagination : 0),
    [currentPage, pageSize, total],
  )
  const showingTo = useMemo(
    () => (currentPage * pageSize < total ? currentPage * pageSize : total),
    [currentPage, pageSize, total],
  )
  const isButtonEnabled = useMemo(() => total / pageSize > 1, [pageSize, total])
  const isLastPage = currentPage === Math.ceil((total ?? 0) / pageSize)
  const isFirstpage = currentPage === defaultPagination

  if (!displayPagination || disableTableControl) {
    return <React.Fragment />
  }

  return (
    <Flex justify={'space-between'} align={'center'} className='table-pagination' >
      <Typography>
        {t('OverallFunctionality:table.pagination.show_result_title', { showingFrom, showingTo, total })}
      </Typography>
      <Flex>
        <Button
          type='text'
          icon={<PaginationFirstIcon fontSize={20} />}
          onClick={onJumpToFirst}
          disabled={!isButtonEnabled || isFirstpage}
        />
        <Pagination
          current={currentPage}
          total={total}
          onChange={onPaginationChange}
          showPrevNextJumpers={true}
          showSizeChanger={false}
          pageSize={pageSize}
        />
        <Button
          type='text'
          icon={<PaginationLastIcon />}
          onClick={onJumpToLast}
          disabled={!isButtonEnabled || isLastPage}
        />
      </Flex>
      <Flex gap={8} align='center'>
        <Typography>{t('OverallFunctionality:table.pagination.rows_per_page_select_title')}</Typography>
        <Select options={pageSizeDropdwonOptions} value={pageSize} onChange={onPageSizeChange} />
      </Flex>
    </Flex>
  )
}

export default TablePagination
